/**
 * AZEFAC Logo — Cormorant Garamond serif wordmark.
 * The first "A" carries a small gold triangle inside its negative space,
 * lifted directly from the brand mark.
 *
 * Props:
 *   size:   "sm" | "md" | "lg"
 *   tone:   "dark"  (default — black text on light bg)
 *           "light" (cream text on dark bg)
 */
export default function Logo({ size = "md", tone = "dark", className = "" }) {
  const sizes = {
    sm: { title: "text-lg lg:text-xl", sub: "text-[7px]", triangle: { w: 5, h: 4, top: "37%" } },
    md: { title: "text-2xl lg:text-3xl", sub: "text-[8px]", triangle: { w: 7, h: 6, top: "37%" } },
    lg: { title: "text-5xl lg:text-7xl", sub: "text-[11px]", triangle: { w: 14, h: 12, top: "38%" } },
  };
  const s = sizes[size] || sizes.md;

  const titleColor = tone === "light" ? "text-[#f5f0e8]" : "text-[#1c1c1c]";
  const subColor   = "text-[#c5a059]";

  return (
    <div data-testid="brand-logo" className={`inline-flex flex-col items-center ${className}`}>
      <div className={`font-display font-light tracking-[0.18em] leading-none ${s.title} ${titleColor}`}>
        <span className="relative inline-block">
          A
          <span
            aria-hidden
            className="absolute left-1/2 -translate-x-1/2 pointer-events-none"
            style={{
              top: s.triangle.top,
              width: 0,
              height: 0,
              borderLeft: `${s.triangle.w / 2}px solid transparent`,
              borderRight: `${s.triangle.w / 2}px solid transparent`,
              borderBottom: `${s.triangle.h}px solid #c5a059`,
            }}
          />
        </span>
        ZEFAC
      </div>
      <span
        className={`mt-1.5 font-body uppercase tracking-[0.42em] ${subColor} ${s.sub}`}
      >
        Properties
      </span>
    </div>
  );
}
